'use client';

import { useTranslations } from 'next-intl';
import { InnerHTML, ProductDetailCarousel } from '@headless-workspace/domain/common/client';
import {
    HTMLString,
    RecommendedProductsValue,
    TileProductAvailabilityValue,
    VipBrandsValue,
} from '@headless-workspace/domain/common/server';
import { GlowContainerSection, PropsWithFontFamily, PropsWithId, PropsWithLocale } from '@headless-workspace/glow-ds';
import { Component } from '@headless-workspace/typings';

type ProductDetailCarouselContainerProps = PropsWithLocale &
    PropsWithFontFamily &
    PropsWithId & {
        vipBrands: VipBrandsValue;
        products: TileProductAvailabilityValue[];
        title?: HTMLString;
        enablePriceExceptionLegalMentions: boolean;
        button?: RecommendedProductsValue['cta'];
    };

export const ProductDetailCarouselContainer: Component<ProductDetailCarouselContainerProps> = ({
    locale,
    vipBrands,
    products,
    title,
    fontFamily,
    enablePriceExceptionLegalMentions,
    button,
}) => {
    const t = useTranslations('Discover.Pdp.carousel');

    return (
        <section className={'flex-col justify-center items-center'}>
            <GlowContainerSection
                className={'gap-1.5 tablet:gap-2 desktop:px-1.5'}
                titleContainerClassName={'px-1 desktop:px-4'}
                title={<InnerHTML rawHtml={title} />}
                button={button}
                fontFamily={fontFamily}
                titleClassName={'line-clamp-2'}
            >
                <ProductDetailCarousel
                    products={products}
                    wishlistBtnAriaLabel={t('ariaLabel.wishlist')}
                    locale={locale}
                    vipBrands={vipBrands}
                    enablePriceExceptionLegalMentions={enablePriceExceptionLegalMentions}
                />
            </GlowContainerSection>
        </section>
    );
};
